export const inventoryCodes = [
  { label: "ACCC", value: "ACCC", description: "Codice Identificativo" },
  { label: "GDS", value: "GDS", description: "Giornale di scavo" },
  { label: "NSC", value: "NSC",  description: "" },
  { label: "NCTN", value: "NCTN",  description: "Numero Cataologo Generale" }
]

